import React from 'react';
import './NavBar.css';
import PropTypes from 'prop-types';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CampusSelect from './CampusSelect';

const drawerWidth = 240;
const navItems = ['Home', 'Module', 'Plan', 'My', 'About'];
const navPage = {
  Home: '/',
  Module: '/course-index',
  Plan: '/plan-index',
  My: '/my',
  About: '/about',
};

function NavBar(props) {
  const theme = createTheme({
    status: {
      danger: '#e53e3e',
    },
    palette: {
      nott: {
        main: 'rgba(255,255,255,0.5)',
        contrastText: 'rgba(27, 42, 107, 0.8)',
        darker: '#053e85',
      },
      neutral: {
        main: 'rgba(27, 42, 107, 0.8)',
        contrastText: '#FFF',
      },
    },
  });

  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container = window !== undefined ? () => window().document.body : undefined;

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Nott Course
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton href={navPage[item]} sx={{ textAlign: 'center' }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <CampusSelect />
    </Box>
  );

  return (
    <div>
      <ThemeProvider theme={theme}>
        <AppBar position="fixed" color="nott" component="nav">
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
              Nott Course
            </Typography>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              {navItems.map((item) => (
                <Button href={navPage[item]} className="page-button" id={item} key={item} sx={{ color: 'rgba(27, 42, 107, 0.8)' }}>
                  {item}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <CampusSelect fontSx={{ color: 'rgba(27, 42, 107, 0.8)' }} />
            </Box>
          </Toolbar>
        </AppBar>
        <Box component="nav">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
      </ThemeProvider>
    </div>
  );
}

NavBar.propTypes = {
  window: PropTypes.func,
};

NavBar.defaultProps = {
  window: undefined,
};

export default NavBar;
